import React from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import { isVideoMimeOrExtension } from './mediaMime';

export function getFileIcon(mimeType, filename, iconSize = 60) {
  const sx = { fontSize: iconSize };
  if (mimeType?.startsWith('image/')) {
    return <ImageIcon sx={{ ...sx, color: 'primary.main' }} />;
  }
  if (mimeType === 'application/pdf' || filename?.toLowerCase().endsWith('.pdf')) {
    return <PictureAsPdfIcon sx={{ ...sx, color: 'error.main' }} />;
  }
  if (isVideoMimeOrExtension(mimeType, filename)) {
    return <VideoFileIcon sx={{ ...sx, color: 'secondary.main' }} />;
  }
  if (mimeType?.includes('word') || mimeType?.includes('document') || filename?.match(/\.(doc|docx)$/i)) {
    return <DescriptionIcon sx={{ ...sx, color: 'info.main' }} />;
  }
  return <InsertDriveFileIcon sx={{ ...sx, color: 'text.secondary' }} />;
}

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}
